import { render } from "./RouteSolve.vue?vue&type=template&id=01acee5d"
import script from "./RouteSolve.vue?vue&type=script&lang=js"
export * from "./RouteSolve.vue?vue&type=script&lang=js"
script.render = render

export default script